export default __webpack_public_path__ + "static/media/Kris of the Star Coffin.c18c7b7a.jpg";